import React, { useState, useEffect, useRef } from "react";
import Sidebar from "../../Components/Sidebar";
import TopNav from "../../Components/TopNav";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  updateProductHeroImage,
  updateProductGalleryServ,
  getProductDetailsServ,
  deleteProductGalleryServ,
  updateProductServ
} from "../../services/product.services";
import { useParams, useNavigate } from "react-router-dom";
function ProductUpdateStep3() {
  const navigate = useNavigate();
  const params = useParams();
  const uploadHeroImage = async (img) => {
    try {
      const formData = new FormData();
      formData.append("productHeroImage", img);
      formData.append("id", params.id);
      let response = await updateProductHeroImage(formData);
      if (response?.data?.statusCode == "200") {
        toast.success(response?.data?.message);
        getProductDetails();
      } else {
        toast.error("Something went wrong");
      }
    } catch (error) {
      toast.error("Internal Server Error");
    }
  };

  const uploadProductGalleryFunc = async (files) => {
    try {
      if (!files || files.length === 0) return;
      const formData = new FormData();
      // append all selected files (backend upload.array supports multiple)
      Array.from(files).forEach((file) => {
        formData.append("productGallery", file);
      });
      formData.append("id", params.id);
      let response = await updateProductGalleryServ(formData);
      if (response?.data?.statusCode == "200") {
        toast.success(response?.data?.message);
        getProductDetails();
      } else {
        toast.error("Something went wrong");
      }
    } catch (error) {
      toast.error("Internal Server Error");
    }
  };
  const [details, setDetails] = useState({
    productHeroImage: "",
    productGallery: [],
  });
  const [productVideoUrl, setProductVideoUrl] = useState("");
  const getProductDetails = async () => {
    try {
      let response = await getProductDetailsServ(params?.id);
      if (response?.data?.statusCode == "200") {
        setDetails({
          productHeroImage: response?.data?.data?.product?.productHeroImage,
          productGallery: response?.data?.data?.product?.productGallery,
        });
        setProductVideoUrl(response?.data?.data?.product?.productVideoUrl);
      }
    } catch (error) {}
  };
  useEffect(() => {
    getProductDetails();
  }, []);

  // ---- Drag & drop reorder of gallery images ----
  const dragIndex = useRef(null);

  const handleDragStart = (index) => {
    dragIndex.current = index;
  };

  const handleDragOver = (e) => {
    e.preventDefault(); // allow drop
  };

  const handleDrop = async (index) => {
    const from = dragIndex.current;
    const to = index;
    dragIndex.current = null;

    if (from === null || from === undefined || from === to) return;

    const updated = [...(details?.productGallery || [])];
    const [moved] = updated.splice(from, 1);
    updated.splice(to, 0, moved);

    // update UI instantly
    setDetails((prev) => ({ ...prev, productGallery: updated }));

    // persist new order
    try {
      let response = await updateProductServ({
        id: params?.id,
        productGallery: updated,
      });
      if (response?.data?.statusCode == "200") {
        toast.success("Image order updated");
      } else {
        toast.error("Could not save new order");
        getProductDetails();
      }
    } catch (error) {
      toast.error("Could not save new order");
      getProductDetails();
    }
  };

  const deleteProductGalleryFunc = async (index) => {
    try {
      let response = await deleteProductGalleryServ({
        id: params?.id,
        index: index,
      });
      if (response?.data?.statusCode == "200") {
        toast.success(response?.data?.message);
        getProductDetails();
      }
    } catch (error) {
      toast.error("Internal Server Error");
    }
  };
  const getYouTubeVideoId = (url) => {
    if(url){
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      const match = url.match(regExp);
      return match && match[2].length === 11 ? match[2] : null;
    } 
    return null;
  };
  const updateProductFunc = async () => {
    try {
      let updatedData = {
        productVideoUrl,
        id: params?.id,
      };
      let response = await updateProductServ(updatedData);
      if (response?.data?.statusCode == "200") {
        toast.success(response?.data?.message);
        
      } else {
        toast.error("Something went wrong");
      }
    } catch (error) {
      toast.error("Internal Server Error");
    }

  };
  
  return (
    <div className="bodyContainer">
      <Sidebar selectedMenu="Product Management" selectedItem="Add Product" />
      <div className="mainContainer">
        <TopNav />
        <div className="p-lg-4 p-md-3 p-2">
          <div
            className="row mx-0 p-0"
            style={{
              position: "relative",
              top: "-75px",
              marginBottom: "-75px",
            }}
          ></div>

          <div className="mt-3">
            <div className="card-body px-2">
              <div className="table-responsive table-invoice">
                <div className="d-flex">
                  <h4
                    className="p-2 text-dark shadow rounded mb-4 "
                    style={{ background: "#05E2B5" }}
                  >
                    Update Product : Step 3/4
                  </h4>
                </div>
              </div>
              <div className="row">
                <div className="col-4 mb-3">
                  <div className="border p-2">
                    <div className="d-flex justify-content-center">
                      <img
                        src={
                          details?.productHeroImage
                            ? details?.productHeroImage
                            : "https://cdn-icons-png.flaticon.com/128/159/159626.png"
                        }
                        className="img-fluid mb-2"
                        style={{ height: "150px" }}
                      />
                    </div>
                    <input
                      className="form-control"
                      type="file"
                      onChange={(e) => uploadHeroImage(e?.target?.files[0])}
                    />
                    <label>Product Hero Image</label>
                  </div>
                </div>
                <div className="col-4 mb-3">
                  <div className="border p-2">
                    <div className="d-flex justify-content-center">
                      {getYouTubeVideoId(productVideoUrl) ? (
                        <iframe
                          width="300"
                          height="128"
                          src={`https://www.youtube.com/embed/${getYouTubeVideoId(productVideoUrl)}`}
                          title="YouTube video preview"
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        ></iframe>
                      ) : (
                        <div style={{ width: "300px", height: "128px", backgroundColor: "#f8f9fa", display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid #ddd" }}>
                          <span className="text-muted" style={{ fontSize: "14px" }}>No valid YouTube URL</span>
                        </div>
                      )}
                    </div>
                    <input className="form-control my-1" type="text" value={productVideoUrl} onChange={(e)=>{
                      getYouTubeVideoId(e?.target?.value);
                      setProductVideoUrl(e?.target?.value);
                    }}/>
                    {productVideoUrl ? <button className=" btn-primary btn-sm w-100" onClick={updateProductFunc}>
                      Upload Video
                    </button>:<button style={{opacity:"0.5"}} className="btn-sm btn-primary  w-100">
                      Upload Video
                    </button>}
                    
                  </div>
                </div>
                <div className="col-12 mb-3">
                  <label>Product Gallery</label>
                  <small className="text-muted ms-2">
                    (Select multiple images at once. Drag images to change their
                    order)
                  </small>
                  <div className="p-2 border d-flex flex-wrap align-items-start">
                    <div className="mx-2 mb-2" style={{ minWidth: "180px" }}>
                      <div className="d-flex justify-content-center">
                        <img
                          src="https://cdn-icons-png.flaticon.com/128/16792/16792767.png"
                          className="img-fluid mb-2"
                        />
                      </div>
                      <input
                        className="form-control"
                        type="file"
                        multiple
                        accept="image/*"
                        onChange={(e) => {
                          uploadProductGalleryFunc(e?.target?.files);
                          e.target.value = "";
                        }}
                      />
                    </div>
                    {details?.productGallery?.map((v, i) => {
                      return (
                        <div
                          key={i}
                          className="p-2 border mx-2 mb-2 position-relative"
                          draggable
                          onDragStart={() => handleDragStart(i)}
                          onDragOver={handleDragOver}
                          onDrop={() => handleDrop(i)}
                          style={{ cursor: "move" }}
                          title="Drag to reorder"
                        >
                          <span
                            className="badge bg-dark position-absolute"
                            style={{ top: "4px", left: "4px", zIndex: 2 }}
                          >
                            {i + 1}
                          </span>
                          <div className="d-flex justify-content-end">
                            <img
                              style={{
                                height: "20px",
                                position: "relative",
                                marginBottom: "-20px",
                                cursor: "pointer",
                              }}
                              onClick={() => deleteProductGalleryFunc(i)}
                              src="https://cdn-icons-png.flaticon.com/128/9068/9068699.png"
                            />
                          </div>
                          <img
                            className="img-fluid"
                            style={{ height: "150px", pointerEvents: "none" }}
                            src={v}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>

                <div className="col-12">
                  <button
                    className="btn btn-primary w-100"
                    style={{
                      background: "#61ce70",
                      border: "none",
                      borderRadius: "24px",
                    }}
                    onClick={() =>
                      navigate("/update-product-attributes/" + params?.id)
                    }
                  >
                    Update
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductUpdateStep3;
